<template>
    <div>
		<b-modal ref="modalPrintReporting" size="lg" hide-footer @show="init_component">
			<template v-slot:modal-title>
				<template>
					{{ $t("horse.print_infos_horse") }}
				</template>
			</template>

			<div class="col-12">
				<div class="form-group">
					<label for="modeltype_label">{{ $t('model.modeltype_label') }} *</label>
					<e-select
						v-model="template"
						id="model_id"
						track-by="model_label"
						label="model_label"
						:placeholder="labelTitleTemplate"
						:deselectLabel="deselectLabel"
						:selectedLabel="selectedLabel"
						:options="templates"
						:searchable="true"
						:allow-empty="false"
						:show-labels="false"
					>
						<template slot="singleLabel" slot-scope="{ option }">{{ option.model_label }}</template>
						<template slot="noOptions">{{ $t('global.list_empty') }}</template>
					</e-select>
				</div>

				<b-button class="mt-3 btn-block rounded-pill" variant="primary" @click="checkForm">{{ $t("global.print") }} <font-awesome-icon v-if="processing" :icon="['fas', 'spinner']" pulse  class="mr-1"/></b-button>
			</div>
		</b-modal>
    </div>
</template>

<script type="text/javascript">
import Gynecologie from "@/mixins/Gynecologie.js"
import Model from "@/mixins/Model.js"

export default {
	name: "ModalPrintReporting",
	mixins: [Gynecologie, Model],
	data () {
		return {
			templates: [],
			template: null,
			processing: false,
			sms_ids: [],
			lines: [],

			deselectLabel: this.getTrad("global.press_enter_to_remove"),
			selectedLabel: this.getTrad("global.selected_label"),
			enter_to_select: this.getTrad("global.press_enter_to_select"),

			labelTitleFormat: this.getTrad("horse.search_format"),
			labelTitleTemplate: this.getTrad("horse.search_doc")
		}
	},
	methods: {
		init_component() {
			this.processing = false
			this.template = null
		},
		async openModal(lines) {
			this.templates = await this.loadAllModel(0, ['reporting_reproduction'])
			this.lines = lines
			this.$refs.modalPrintReporting.show()
		},
		async checkForm() {
			if(this.template) {
				this.processing = true
				this.printReportingReproduction(this.lines, this.template.model_id)
				.then(() => {
					this.processing = false
					this.$refs.modalPrintReporting.hide()
				})
			}
			else {
				this.failureToast()
			}
		}
	}
}
</script>